export default __webpack_public_path__ + "static/media/1792.7e8a22a9.png";